document.addEventListener('DOMContentLoaded', function() {
  // Safe automated injection setup for Lightbox Modal structure elements if missing from Template
  let modal = document.getElementById('reels-video-modal');
  if (!modal) {
    modal = document.createElement('div');
    modal.id = 'reels-video-modal';
    modal.className = 'reels-lightbox-modal';
    modal.innerHTML = `
      <div class="reels-modal-overlay"></div>
      <div class="reels-modal-wrapper">
        <button class="reels-modal-close" aria-label="Close Playback">×</button>
        <div class="reels-modal-body-content"></div>
      </div>
    `;
    document.body.appendChild(modal);
  }
  
  const modalBody = modal.querySelector('.reels-modal-body-content');
  const modalClose = modal.querySelector('.reels-modal-close');
  const modalOverlay = modal.querySelector('.reels-modal-overlay');

  const initPremium3DSection = (section) => {
    const carousel = section.querySelector('.reels-carousel');
    const cards = section.querySelectorAll('.reel-card');
    const prevBtn = section.querySelector('.prev-btn');
    const nextBtn = section.querySelector('.next-btn');
    
    const titleField = section.querySelector('#dynamic-reel-title');
    const descField = section.querySelector('#dynamic-reel-desc');
    const productBox = section.querySelector('#dynamic-reel-product');
    const shopLink = section.querySelector('.premium-cta-arrow');
    
    const totalCards = cards.length;
    if (totalCards === 0 || !carousel) return;

    let currentIndex = 0;

    function getAdaptiveRadius() {
      const currentCardWidth = carousel.offsetWidth || 410;
      return Math.max(300, Math.round((currentCardWidth / 2) / Math.tan(Math.PI / totalCards)) + 60);
    }

    function updateRightTextPanel(activeCard) {
      const title = activeCard.getAttribute('data-title');
      const desc = activeCard.getAttribute('data-desc');
      const prodTitle = activeCard.getAttribute('data-product-title');
      const prodPrice = activeCard.getAttribute('data-product-price');
      const prodUrl = activeCard.getAttribute('data-product-url');

      if (titleField && descField) {
        titleField.style.opacity = '0';
        descField.style.opacity = '0';
        
        setTimeout(() => {
          titleField.textContent = title || "";
          descField.textContent = desc || "";
          titleField.style.opacity = '1';
          descField.style.opacity = '1';
        }, 200);
      }

      if (prodTitle && productBox) {
        section.querySelector('.prod-badge-title').textContent = prodTitle;
        // HTML parsing for multi-currency symbols
        section.querySelector('.prod-badge-price').innerHTML = prodPrice || "";
        
        if (shopLink) {
          shopLink.setAttribute('href', prodUrl || '#');
        }
        productBox.classList.add('visible');
      } else if (productBox) {
        productBox.classList.remove('visible');
      }
    }

    function updateCarousel() {
      const radius = getAdaptiveRadius();
      const anglePerCard = 360 / totalCards;
      const theta = anglePerCard * currentIndex * -1;
      
      carousel.style.transform = `translateZ(-${radius}px) rotateY(${theta}deg)`;
      
      cards.forEach((card, i) => {
        const cardAngle = anglePerCard * i;
        card.style.transform = `rotateY(${cardAngle}deg) translateZ(${radius}px)`;
        
        const normalizedCurrent = ((currentIndex % totalCards) + totalCards) % totalCards;
        const videoElement = card.querySelector('video');
        
        if (i === normalizedCurrent) {
          card.classList.add('active');
          card.style.pointerEvents = 'auto';
          updateRightTextPanel(card);
          
          if (videoElement) {
            videoElement.play().catch(() => {});
            togglePlaybackIcons(card, true);
          }
        } else {
          card.classList.remove('active');
          card.style.pointerEvents = 'none';
          if (videoElement) {
            videoElement.pause();
          }
        }
      });
    }

    function togglePlaybackIcons(card, isPlaying) {
      let playIcon = card.querySelector('.icon-play-overlay');
      let pauseIcon = card.querySelector('.icon-pause-overlay');
      
      if (!playIcon || !pauseIcon) {
        const ctrlBox = card.querySelector('.reel-video-playback-control');
        if (ctrlBox) {
          ctrlBox.innerHTML = '<span class="icon-play-overlay">▶</span><span class="icon-pause-overlay" style="display:none;">❚❚</span>';
          playIcon = ctrlBox.querySelector('.icon-play-overlay');
          pauseIcon = ctrlBox.querySelector('.icon-pause-overlay');
        }
      }

      if (playIcon && pauseIcon) {
        if (isPlaying) {
          playIcon.style.display = 'none';
          pauseIcon.style.display = 'block';
        } else {
          playIcon.style.display = 'block';
          pauseIcon.style.display = 'none';
        }
      }
    }

    // DEFINITIVE LINK FIX: Bypasses event capturing and forces direct window redirection
    if (shopLink) {
      shopLink.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const targetUrl = this.getAttribute('href');
        if (targetUrl && targetUrl !== '#') {
          window.location.href = targetUrl;
        }
      });
    }

    cards.forEach((card) => {
      const playBtn = card.querySelector('.reel-video-playback-control');
      const videoElement = card.querySelector('video');

      if (playBtn && videoElement) {
        playBtn.addEventListener('click', function(e) {
          e.stopPropagation(); 
          if (!card.classList.contains('active')) return;
          
          if (videoElement.paused) {
            videoElement.play().catch(() => {});
            togglePlaybackIcons(card, true);
          } else {
            videoElement.pause();
            togglePlaybackIcons(card, false);
          }
        });
      }

      card.addEventListener('click', function(e) {
        if (!card.classList.contains('active')) return;
        if (e.target.closest('.reel-video-playback-control')) return;

        if (videoElement && modal && modalBody) {
          videoElement.pause();
          togglePlaybackIcons(card, false);
          
          modalBody.innerHTML = `<video src="${videoElement.currentSrc || videoElement.src}" controls autoplay playsinline loop></video>`;
          modal.classList.add('active');
        }
      });
    });

    const closeModalFunc = () => {
      if (!modal || !modalBody) return;
      modal.classList.remove('active');
      modalBody.innerHTML = '';
      
      const activeCard = section.querySelector('.reel-card.active');
      const activeVideo = activeCard ? activeCard.querySelector('video') : null;
      if (activeVideo) {
        activeVideo.play().catch(() => {});
        togglePlaybackIcons(activeCard, true);
      }
    };

    if (modalClose) modalClose.onclick = closeModalFunc;
    if (modalOverlay) modalOverlay.onclick = closeModalFunc;

    nextBtn.addEventListener('click', () => { currentIndex++; updateCarousel(); });
    prevBtn.addEventListener('click', () => { currentIndex--; updateCarousel(); });

    window.addEventListener('resize', updateCarousel);
    updateCarousel();
  };

  document.querySelectorAll('.reels-premium-layout').forEach(initPremium3DSection);
});